export const DataBi7drr = [
  {
	date: '24 April 2024',
	interest: 0.0625,
	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_268024.aspx',
  },
  {
  	date: '20 March 2024',
  	interest: 0.06,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_265424.aspx',
  },
  {
  	date: '21 February 2024',
  	interest: 0.06,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_263324.aspx',
  },
  {
  	date: '17 January 2024',
  	interest: 0.06,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_260924.aspx',
  },
  {
  	date: '21 December 2023',
  	interest: 0.06,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2534223.aspx',
  },
  {
  	date: '23 November 2023',
  	interest: 0.06,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2531723.aspx',
  },
  {
  	date: '19 October 2023',
  	interest: 0.06,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2528323.aspx',
  },
  {
  	date: '21 September 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2525923.aspx',
  },
  {
  	date: '24 August 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2523323.aspx',
  },
  {
  	date: '25 July 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2519723.aspx',
  },
  {
  	date: '22 June 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2516523.aspx',
  },
  {
  	date: '25 May 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2514023.aspx',
  },
  {
  	date: '18 April 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2510223.aspx',
  },
  {
  	date: '16 March 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_256523.aspx',
  },
  {
  	date: '16 February 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_253823.aspx',
  },
  {
  	date: '19 January 2023',
  	interest: 0.0575,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_251323.aspx',
  },
  {
  	date: '22 December 2022',
  	interest: 0.055,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2435022.aspx',
  },
  {
  	date: '17 November 2022',
  	interest: 0.0525,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2431322.aspx',
  },
  {
  	date: '20 October 2022',
  	interest: 0.0475,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2428522.aspx',
  },
  {
  	date: '22 September 2022',
  	interest: 0.0425,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2425322.aspx',
  },
  {
  	date: '23 August 2022',
  	interest: 0.0375,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2422622.aspx',
  },
  {
  	date: '21 July 2022',
  	interest: 0.035,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2419522.aspx',
  },
  {
  	date: '23 June 2022',
  	interest: 0.035,
  	url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2415922.aspx',
  },
  {
    date: '24 May 2022',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2413622.aspx',
  },
  {
    date: '19 April 2022',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2410822.aspx',
  },
  {
    date: '17 March 2022',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_248322.aspx',
  },
  {
    date: '10 February 2022',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_244122.aspx',
  },
  {
    date: '20 January 2022',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_241522.aspx',
  },
  {
    date: '16 December 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2333221.aspx',
  },
  {
    date: '18 November 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2330421.aspx',
  },
  {
    date: '19 October 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2326821.aspx',
  },
  {
    date: '21 September 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2324121.aspx',
  },
  {
    date: '19 August 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2321321.aspx',
  },
  {
    date: '22 July 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2317721.aspx',
  },
  {
    date: '17 June 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2314421.aspx',
  },
  {
    date: '25 May 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2312921.aspx',
  },
  {
    date: '20 April 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_2310521.aspx',
  },
  {
    date: '18 March 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_236821.aspx',
  },
  {
    date: '18 February 2021',
    interest: 0.035,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_234221.aspx',
  },
  {
    date: '21 January 2021',
    interest: 0.0375,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_232021.aspx',
  },
  {
    date: '17 December 2020',
    interest: 0.0375,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_229520.aspx',
  },
  {
    date: '19 November 2020',
    interest: 0.0375,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_228720.aspx',
  },
  {
    date: '13 October 2020',
    interest: 0.04,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_227520.aspx',
  },
  {
    date: '17 September 2020',
    interest: 0.04,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_227120.aspx',
  },
  {
    date: '19 August 2020',
    interest: 0.04,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_226420.aspx',
  },
  {
    date: '16 July 2020',
    interest: 0.04,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_225220.aspx',
  },
  {
    date: '18 June 2020',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_224620.aspx',
  },
  {
    date: '19 May 2020',
    interest: 0.045,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_223920.aspx',
  },
  {
    date: '14 April 2020',
    interest: 0.045,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_223020.aspx',
  },
  {
    date: '19 March 2020',
    interest: 0.045,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_222220.aspx',
  },
  {
    date: '20 February 2020',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_221320.aspx',
  },
  {
    date: '23 January 2020',
    interest: 0.05,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_220420.aspx',
  },
  {
    date: '19 December 2019',
    interest: 0.05,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_218819.aspx',
  },
  {
    date: '21 November 2019',
    interest: 0.05,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_218219.aspx',
  },
  {
    date: '24 October 2019',
    interest: 0.05,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_217519.aspx',
  },
  {
    date: '19 September 2019',
    interest: 0.0525,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_216819.aspx',
  },
  {
    date: '22 August 2019',
    interest: 0.055,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_216319.aspx',
  },
  {
    date: '18 July 2019',
    interest: 0.0575,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_215219.aspx',
  },
  {
    date: '20 June 2019',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_214619.aspx',
  },
  {
    date: '16 May 2019',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_213719.aspx',
  },
  {
    date: '25 April 2019',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_212519.aspx',
  },
  {
    date: '21 March 2019',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_211719.aspx',
  },
  {
    date: '21 February 2019',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_211219.aspx',
  },
  {
    date: '17 January 2019',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_21419.aspx',
  },
  {
    date: '20 December 2018',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_209618.aspx',
  },
  {
    date: '15 November 2018',
    interest: 0.06,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_208718.aspx',
  },
  {
    date: '23 October 2018',
    interest: 0.0575,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_208218.aspx',
  },
  {
    date: '27 September 2018',
    interest: 0.0575,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_207318.aspx',
  },
  {
    date: '15 August 2018',
    interest: 0.055,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_206618.aspx',
  },
  {
    date: '19 July 2018',
    interest: 0.0525,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_205518.aspx',
  },
  {
    date: '29 June 2018',
    interest: 0.0525,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_205118.aspx',
  },
  {
    date: '30 May 2018',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_204618.aspx',
  },
  {
    date: '17 May 2018',
    interest: 0.045,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_204418.aspx',
  },
  {
    date: '19 April 2018',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_203218.aspx',
  },
  {
    date: '22 March 2018',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_202318.aspx',
  },
  {
    date: '15 February 2018',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_201418.aspx',
  },
  {
    date: '18 January 2018',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_200618.aspx',
  },
  {
    date: '14 December 2017',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_199517.aspx',
  },
  {
    date: '16 November 2017',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_198717.aspx',
  },
  {
    date: '19 October 2017',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_197917.aspx',
  },
  {
    date: '22 September 2017',
    interest: 0.0425,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_197317.aspx',
  },
  {
    date: '22 August 2017',
    interest: 0.045,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_196417.aspx',
  },
  {
    date: '20 July 2017',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_195317.aspx',
  },
  {
    date: '15 June 2017',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_19462017.aspx',
  },
  {
    date: '18 May 2017',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_194017.aspx',
  },
  {
    date: '20 April 2017',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_192917.aspx',
  },
  {
    date: '16 March 2017',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_192217.aspx',
  },
  {
    date: '16 February 2017',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_191417.aspx',
  },
  {
    date: '19 January 2017',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_190617.aspx',
  },
  {
    date: '15 December 2016',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_1810216.aspx',
  },
  {
    date: '17 November 2016',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_189416.aspx',
  },
  {
    date: '20 October 2016',
    interest: 0.0475,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_188416.aspx',
  },
  {
    date: '22 September 2016',
    interest: 0.05,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_187816.aspx',
  },
  {
    date: '19 August 2016',
    interest: 0.0525,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_186716.aspx',
  },
  {
    date: '21 July 2016',
    interest: 0.0525,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_185616.aspx',
  },
  {
    date: '16 June 2016',
    interest: 0.0525,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_185016.aspx',
  },
  {
    date: '19 May 2016',
    interest: 0.055,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/SP_183816.aspx',
  },
  {
    date: '21 April 2016',
    interest: 0.055,
    url: 'https://www.bi.go.id/id/publikasi/ruang-media/news-release/Pages/sp_183116.aspx',
  },
];
